import $, { data, getJSON, inArray, isEmptyObject } from 'jquery';
import NavigationWishlist from './NavigationWishlist';
import WoocommerceProducts from './WoocommerceProducts';
import Counter from './../Counter';
/* ===============================================================
  WoocommerceArchive
=============================================================== */
class WoocommerceArchive {
    constructor() {
        this.productListWrapper = $('.irantheme-wc-archive-products');
        this.pageType = this.productListWrapper.attr('data-page');
        // Get irantheme navigation
        this.navigationFilter = $('.irantheme-woocommerce-filter-navigation');
        // Get close button
        this.btnClose = this.navigationFilter.find(
            '.irantheme-woocommerce-filter-navigation-header-close',
        );
        // Get wrapper mask
        this.wrapperMask = $('#irantheme-wrapper-mask');
        // Get apply filter button
        this.applyFilterBtn = this.navigationFilter.find(
            '.irantheme-woocommerce-filter-navigation-footer-apply',
        );
        // Get clear all filter button
        this.clearFilterBtn = this.navigationFilter.find(
            '.irantheme-woocommerce-filter-navigation-footer-clear',
        );
        this.filterNavigationEnable();
        this.events();
    }

    events() {
        let current = this;
        // First load ajax product

        $(document).on('ready', function (e) {
            // Run in wc archive page only
            if ($('.irantheme-wc-archive').length > 0) {
                // Checking the type of page that should not be of category,tag,tax,author type
                if (
                    !['category', 'tag', 'tax', 'author'].includes(
                        current.pageType,
                    )
                ) {
                    // Call ajax apply filter
                    current.applyArchiveFilter(0);
                }
                // Call assign value of selected filter from url to filtering elements
                current.filterCheckboxChecker();
            }
        });

        // Add active style to wc shop search box
        $('#irantheme_wc_shop_search').on('focus', function (e) {
            $(this)
                .parents('.irantheme-wc-archive-search-wrapper')
                .addClass('active');
        });
        // remove active style to wc shop search box
        $('#irantheme_wc_shop_search').on('blur', function (e) {
            $(this)
                .parents('.irantheme-wc-archive-search-wrapper')
                .removeClass('active');
        });

        this.orderbyListClickable();
        this.productsResultCount();
        this.filteringStatusToggle();
        this.priceMultiRangeSlider();
        this.detectsChangesFilters();
        this.paginationAction();
        $(window).on('resize', () => {
            this.filterNavigationEnable();
        });
        this.btnClose.on('click', () => {
            this.close();
        });
        this.wrapperMask.on('click', () => {
            this.close();
        });
        this.applyFilterBtn.on('click', () => {
            this.applyFilterMobile();
        });
        this.clearFilterBtn.on('click', () => {
            this.clearFilterMobile();
        });

        this.filterWrapperToggler();
        this.clearAllFilterInDesktopByClearBtn();
    }

    statusOfClearBtnInDesktop(flag) {
        let clearBtn = $(
            '.irantheme-wc-archive-top-bar .irantheme-woocommerce-filter-clear',
        );
        if (flag) {
            if (!clearBtn.hasClass('active')) {
                clearBtn.addClass('active');
            }
        } else {
            clearBtn.removeClass('active');
        }
    }

    // Toggle root of category
    filterWrapperToggler() {
        // When category selected
        $(document).on('ready', function (e) {
            let inputsChecked = $(
                "input:checkbox[name='product_category_item[]']:checked",
            );
            if (inputsChecked.length) {
                // Close all wrapper
                $(
                    '.irantheme-wc-archive-filter-category-children-wrapper',
                ).removeClass('active');
                $('.irantheme-wc-archive-filter-category-children-wrapper').css(
                    'display',
                    'none',
                );
                inputsChecked.each(function (index, element) {
                    let childrenWrapper = $(element).parents(
                        '.irantheme-wc-archive-filter-category-children-wrapper',
                    );
                    // Open wrapper
                    childrenWrapper.addClass('active');
                    childrenWrapper.css('display', 'block');
                });
            }
        });
        // When OnClick
        $('.irantheme-wc-archive-filter-content-label-toggler').on(
            'click',
            function (e) {
                let childrenWrapper = $(this)
                    .parents('.irantheme-wc-cat-has-parent')
                    .siblings(
                        '.irantheme-wc-archive-filter-category-children-wrapper',
                    );
                if (childrenWrapper.hasClass('active')) {
                    childrenWrapper.removeClass('active');
                    childrenWrapper.slideUp(250);
                } else {
                    childrenWrapper.addClass('active');
                    childrenWrapper.slideDown(250);
                }
                // Prevent check input checkbox
                return false;
            },
        );
    }

    // Get category from url on postname permalink type
    getCategoryFromUrlPostNamePermalink() {
        let str = window.location.pathname;
        if (str[str.length - 1] == '/') {
            str = str.slice(0, str.length - 1);
        }
        return str.substring(str.lastIndexOf('/') + 1);
    }

    // Assign value to filters element from url parameter
    filterCheckboxChecker() {
        let current = this;
        // Get all checkbox of categories
        let checkboxesCategory = $(
            "input:checkbox[name='product_category_item[]']",
        );
        // Check permalink type (if is a empty is equal to simple permalink otherwise is equal to postname permalink and other)
        if (iranthemeWpData.permalink_type == '') {
            // Check category selected received from url parameter
            if (this.getURLParameter('p_category') != undefined) {
                let data_param = this.getURLParameter('p_category').split(',');
                checkboxesCategory.each(function (index, element) {
                    data_param.forEach((paramElem) => {
                        if ($(element).val() == paramElem) {
                            // Assign the Checked property to the checkbox corresponding to the selected category
                            $(element).prop('checked', true);
                        }
                    });
                });
            } else if (this.getURLParameter('product_cat') != undefined) {
                let data_param = this.getURLParameter('product_cat').split(',');
                checkboxesCategory.each(function (index, element) {
                    data_param.forEach((paramElem) => {
                        if ($(element).val() == paramElem) {
                            // Assign the Checked property to the checkbox corresponding to the selected category
                            $(element).prop('checked', true);
                        }
                    });
                });
            }
        } else {
            // Check category selected received from url parameter in postname permalink type
            if (window.location.pathname.indexOf('product-category') >= 0) {
                checkboxesCategory.each(function (index, element) {
                    if (
                        $(element).val() ==
                        current.getCategoryFromUrlPostNamePermalink()
                    ) {
                        // Assign the Checked property to the checkbox corresponding to the selected category
                        $(element).prop('checked', true);
                    }
                });
            } else {
                if (this.getURLParameter('p_category') != undefined) {
                    let data_param =
                        this.getURLParameter('p_category').split(',');
                    checkboxesCategory.each(function (index, element) {
                        data_param.forEach((paramElem) => {
                            if ($(element).val() == paramElem) {
                                // Assign the Checked property to the checkbox corresponding to the selected category
                                $(element).prop('checked', true);
                            }
                        });
                    });
                } else if (this.getURLParameter('product_cat') != undefined) {
                    let data_param =
                        this.getURLParameter('product_cat').split(',');
                    checkboxesCategory.each(function (index, element) {
                        data_param.forEach((paramElem) => {
                            if ($(element).val() == paramElem) {
                                // Assign the Checked property to the checkbox corresponding to the selected category
                                $(element).prop('checked', true);
                            }
                        });
                    });
                }
            }
        }

        // Get search keyword
        let searchInput = $('#irantheme_wc_shop_search');
        // Check ordering type selected received from url parameter
        if (this.getURLParameter('search') != undefined) {
            let data_param = this.getURLParameter('search');
            searchInput.val(data_param);
        }

        // Get ordering type list
        let orderingType = $(
            '.irantheme-woocommerce-ordering-wrapper.irantheme-wc-ajax-ordering',
        ).find('.irantheme-woocommerce-ordering-list-item');
        // Get ordering type title
        let orderingTitle = $('.irantheme-woocommerce-ordering-wrapper').find(
            '.irantheme-woocommerce-ordering-title span',
        );
        // Check ordering type selected received from url parameter
        if (this.getURLParameter('ordering_type') != undefined) {
            let data_param = this.getURLParameter('ordering_type').split(',');
            orderingType.each(function (index, element) {
                data_param.forEach((paramElem) => {
                    if ($(element).attr('data-value') == paramElem) {
                        // Add class active to ordering type selected element
                        $(element).addClass('active');
                        // Add text of selected ordering type to title of ordering type element
                        $(orderingTitle).text($(element).text());
                    } else {
                        // Remove active class from another items
                        $(element).removeClass('active');
                    }
                });
            });
        }

        // Check object parameter is not empty
        if (!isEmptyObject(this.getURLParameter())) {
            // Get json of url parameter
            let data_param = this.getURLParameter();
            // Loop on url json object
            Object.keys(data_param).map(function (objectKey, index) {
                // split value of current object key
                let objectValue = data_param[objectKey].split(',');
                // Get related input checkbox
                let filterCheckbox = $(
                    '.irantheme-wc-archive-filter-' +
                        objectKey.replace('filter_', ''),
                ).find("input:checkbox[name='product_filter_item[]']");
                filterCheckbox.each(function (index, element) {
                    objectValue.forEach((objectElem) => {
                        if ($(element).val() == objectElem) {
                            // Assign the Checked property to the checkbox corresponding to the selected brand
                            $(element).prop('checked', true);
                        }
                    });
                });
            });
        }

        // Get in stock checkbox
        let checkboxesStatusStock = $(
            "input:checkbox[name='product_status_in_stock']",
        );
        // Check in stock status received from url parameter
        if (this.getURLParameter('in_stock') != undefined) {
            let data_param = this.getURLParameter('in_stock').split(',');
            if (data_param == 'true') {
                checkboxesStatusStock.prop('checked', true);
            }
        }
        // Get on sale checkbox
        let checkboxesStatusSale = $(
            "input:checkbox[name='product_status_on_sale']",
        );
        // Check on sale status received from url parameter
        if (this.getURLParameter('on_sale') != undefined) {
            let data_param = this.getURLParameter('on_sale').split(',');
            if (data_param == 'true') {
                checkboxesStatusSale.prop('checked', true);
            }
        }
        // Get price start input
        let inputPriceFrom = $(
            "input[name='irantheme_price_filter_input_from']",
        );
        // Check price start received from url parameter
        if (this.getURLParameter('price_from') != undefined) {
            let data_param = this.getURLParameter('price_from');
            inputPriceFrom.val(data_param);
        }
        // Get price end input
        let inputPriceTo = $("input[name='irantheme_price_filter_input_to']");
        // Check price end received from url parameter
        if (this.getURLParameter('price_to') != undefined) {
            let data_param = this.getURLParameter('price_to');
            inputPriceTo.val(data_param);
        }
        // Get price range
        let priceToRange = $('#toSliderRangeInput');
        let priceFromRange = $('#fromSliderRangeInput');
        // Check price start received from url parameter
        if (this.getURLParameter('price_from') != undefined) {
            let data_param = this.getURLParameter('price_from');
            priceFromRange.val(data_param);
            this.priceMultiRangeSlider();
        }
        // Check price end received from url parameter
        if (this.getURLParameter('price_to') != undefined) {
            let data_param = this.getURLParameter('price_to');
            priceToRange.val(data_param);
            this.priceMultiRangeSlider();
        }
    }

    // Enable action of clear all filter in desktop mode
    clearAllFilterInDesktopByClearBtn() {
        let clearBtn = $(
            '.irantheme-wc-archive-top-bar .irantheme-woocommerce-filter-clear',
        );
        let current = this;
        $(clearBtn).on('click', function (e) {
            current.clearFilterMobile();
            clearBtn.removeClass('active');
        });
    }

    productsResultCount() {
        let resultCountWrapper = $(
            '.irantheme-wc-archive-top-bar .irantheme-woocommerce-result-count-wrapper',
        );
        if (resultCountWrapper.length > 0) {
            let resultCountPresentableFrom = $(resultCountWrapper)
                .find('.irantheme-woocommerce-result-count')
                .find('.result-count-presentable')
                .children('.result-count-presentable-from');
            let resultCountPresentableTo = $(resultCountWrapper)
                .find('.irantheme-woocommerce-result-count')
                .find('.result-count-presentable')
                .children('.result-count-presentable-to');
            let resultCountTotal = $(resultCountWrapper)
                .find('.irantheme-woocommerce-result-count')
                .find('.result-count-total');
            let productSectionWrapper = $(
                '.irantheme-woocommerce-products-section',
            );
            let dataOffset = parseInt(
                productSectionWrapper.attr('data-offset'),
            );
            let dataTotal = parseInt(
                productSectionWrapper.attr('data-Products'),
            );
            let dataPerPage = parseInt(
                productSectionWrapper.attr('data-per-page'),
            );

            $(resultCountPresentableFrom).html(dataOffset + 1);
            let resultTemp = dataOffset + dataPerPage;
            if (resultTemp <= dataTotal) {
                $(resultCountPresentableTo).html(resultTemp);
            } else {
                $(resultCountPresentableTo).html(dataTotal);
            }
            $(resultCountTotal).html(dataTotal);
        }
    }

    priceMultiRangeSlider() {
        const baseColor = $('.irantheme-wc-archive');
        let COLOR_TRACK = '#CBD5E1';
        let COLOR_RANGE = '#2a2e33';
        if (baseColor.hasClass('dark')) {
            COLOR_TRACK = '#2a2e33';
            COLOR_RANGE = '#CBD5E1';
        }

        const fromSlider = $(
            '.irantheme-wc-archive-filter.filter-enable .irantheme-wc-archive-filter-price',
        ).find('#fromSliderRangeInput');
        const fromSliderInput = $(
            '.irantheme-wc-archive-filter.filter-enable .irantheme-wc-archive-filter-price',
        ).find('#irantheme_price_filter_input_from');
        const toSlider = $(
            '.irantheme-wc-archive-filter.filter-enable .irantheme-wc-archive-filter-price',
        ).find('#toSliderRangeInput');
        const toSliderInput = $(
            '.irantheme-wc-archive-filter.filter-enable .irantheme-wc-archive-filter-price',
        ).find('#irantheme_price_filter_input_to');
        const fromTooltip = $(
            '.irantheme-wc-archive-filter.filter-enable .irantheme-wc-archive-filter-price',
        ).find('#fromSliderTooltipRange');
        const toTooltip = $(
            '.irantheme-wc-archive-filter.filter-enable .irantheme-wc-archive-filter-price',
        ).find('#toSliderTooltipRange');

        function controlFromSlider(fromSlider, toSlider, fromSliderInput) {
            const [from, to] = getParsed(fromSlider, toSlider);
            fillSlider(
                fromSlider,
                toSlider,
                COLOR_TRACK,
                COLOR_RANGE,
                toSlider,
            );
            if (from > to) {
                fromSlider.val(to);
            }
            setInputValue(fromSlider, fromSliderInput);
        }

        function controlToSlider(fromSlider, toSlider, toSliderInput) {
            const [from, to] = getParsed(fromSlider, toSlider);
            fillSlider(
                fromSlider,
                toSlider,
                COLOR_TRACK,
                COLOR_RANGE,
                toSlider,
            );
            setToggleAccessible(toSlider);
            if (from <= to) {
                toSlider.val(to);
            } else {
                toSlider.val(from);
            }
            setInputValue(toSlider, toSliderInput);
        }

        function getParsed(currentFrom, currentTo) {
            const from = parseInt(currentFrom.val(), 10);
            const to = parseInt(currentTo.val(), 10);
            return [from, to];
        }

        $('#irantheme_price_filter_input_from').on('keyup', function () {
            $('#fromSliderRangeInput').val(
                $('#irantheme_price_filter_input_from').val(),
            );
            fillSlider(
                fromSlider,
                toSlider,
                COLOR_TRACK,
                COLOR_RANGE,
                toSlider,
            );
        });
        $('#irantheme_price_filter_input_to').on('keyup', function () {
            $('#toSliderRangeInput').val(
                $('#irantheme_price_filter_input_to').val(),
            );
            fillSlider(
                fromSlider,
                toSlider,
                COLOR_TRACK,
                COLOR_RANGE,
                toSlider,
            );
        });

        function fillSlider(from, to, sliderColor, rangeColor, controlSlider) {
            const rangeDistance = to.prop('max') - to.prop('min');
            const fromPosition = from.val() - to.prop('min');
            const toPosition = to.val() - to.prop('min');
            controlSlider.css(
                'background',
                `linear-gradient(
          to right,
          ${sliderColor} 0%,
          ${sliderColor} ${(fromPosition / rangeDistance) * 100}%,
          ${rangeColor} ${(fromPosition / rangeDistance) * 100}%,
          ${rangeColor} ${(toPosition / rangeDistance) * 100}%, 
          ${sliderColor} ${(toPosition / rangeDistance) * 100}%, 
          ${sliderColor} 100%`,
            );
        }

        function setToggleAccessible(currentTarget) {
            const toSlider = $(
                '.irantheme-wc-archive-filter .irantheme-wc-archive-filter-price',
            ).find('#toSliderRangeInput');
            if (Number(currentTarget.value) <= 0) {
                toSlider.css('z-index', '2');
            } else {
                toSlider.css('z-index', '0');
            }
        }

        function setInputValue(slider, input) {
            const value = slider.val();
            $(input).val(value);
        }

        // events
        $(fromSlider).on('input', function (e) {
            controlFromSlider(fromSlider, toSlider, fromSliderInput);
        });
        $(toSlider).on('input', function (e) {
            controlToSlider(fromSlider, toSlider, toSliderInput);
        });

        // Initial load
        fillSlider(fromSlider, toSlider, COLOR_TRACK, COLOR_RANGE, toSlider);
        setToggleAccessible(toSlider);
    }

    orderbyListClickable() {
        let current = this;
        $(
            '.irantheme-woocommerce-ordering-wrapper.irantheme-wc-ajax-ordering',
        ).on('mouseenter', function (e) {
            $(this).addClass('active');
        });
        $(
            '.irantheme-woocommerce-ordering-wrapper.irantheme-wc-ajax-ordering',
        ).on('mouseleave', function (e) {
            $(this).removeClass('active');
        });
        $(
            '.irantheme-woocommerce-ordering-wrapper.irantheme-wc-ajax-ordering',
        ).on(
            'click',
            '.irantheme-woocommerce-ordering-list-item',
            function (e) {
                let orderWrapperAjax = $(
                    '.irantheme-woocommerce-ordering-wrapper.irantheme-wc-ajax-ordering',
                );
                let orderTitle = $(
                    '.irantheme-woocommerce-ordering-wrapper .irantheme-woocommerce-ordering-title span',
                );
                let listItemSelected = $(this);
                let itemSelectedValue = listItemSelected.attr('data-value');
                let allListItem = $(orderWrapperAjax).find(
                    '.irantheme-woocommerce-ordering-list-item',
                );
                $(allListItem).removeClass('active');
                allListItem.each(function (index, element) {
                    if ($(element).attr('data-value') == itemSelectedValue) {
                        $(element).addClass('active');
                        $(orderTitle).text($(element).text());
                        current.addURLFilterParameter(0);
                    }
                });
            },
        );
    }

    // Show and hide filter sidebar btn
    filteringStatusToggle() {
        let statusToggler = $('.irantheme-woocommerce-filtering-status');
        let mainWrapper = $('.irantheme-wc-archive');
        let current = this;
        statusToggler.on('click', function (e) {
            if (mainWrapper.hasClass('irantheme-wc-filter-sidebar')) {
                current.navigationFilter.addClass('active');
                current.wrapperMask.fadeIn();
                statusToggler.addClass('active');
            } else {
                if (
                    mainWrapper.hasClass('irantheme-wc-archive-show-filtering')
                ) {
                    mainWrapper.removeClass(
                        'irantheme-wc-archive-show-filtering',
                    );
                    mainWrapper.addClass('irantheme-wc-archive-hide-filtering');
                } else if (
                    mainWrapper.hasClass('irantheme-wc-archive-hide-filtering')
                ) {
                    mainWrapper.removeClass(
                        'irantheme-wc-archive-hide-filtering',
                    );
                    mainWrapper.addClass('irantheme-wc-archive-show-filtering');
                }
            }
        });
    }

    addURLFilterParameter(pageNumber = 0) {
        var params = {};

        let search_keyword = $('#irantheme_wc_shop_search').val();
        if (search_keyword != '') {
            params['search'] = search_keyword;
        }

        let checkboxesCategory = $(
            "input:checkbox[name='product_category_item[]']:checked",
        );
        let categoriesSelected = '';
        checkboxesCategory.each(function (index, element) {
            categoriesSelected += $(element).val() + ',';
        });
        if (
            categoriesSelected != '' &&
            window.location.pathname.indexOf('product-category') == -1
        ) {
            if (!['category', 'tag', 'tax', 'author'].includes(this.pageType)) {
                params['p_category'] = categoriesSelected;
            } else {
                params['product_cat'] = categoriesSelected;
            }
        }
        let orderingType = $(
            '.irantheme-woocommerce-ordering-wrapper.irantheme-wc-ajax-ordering',
        )
            .find('.irantheme-woocommerce-ordering-list-item.active')
            .attr('data-value');
        if (orderingType != '') {
            params['ordering_type'] = orderingType;
        }
        // let checkboxesBrand = $(
        //     "input:checkbox[name='product_brand_item[]']:checked"
        // );
        // let brandsSelected = '';
        // checkboxesBrand.each(function (index, element) {
        //     brandsSelected += $(element).val() + ',';
        // });
        // if (brandsSelected != '') {
        //     params['brands'] = brandsSelected;
        // }
        // let checkboxesColor = $(
        //     "input:checkbox[name='product_color_item[]']:checked"
        // );
        // let colorsSelected = '';
        // checkboxesColor.each(function (index, element) {
        //     colorsSelected += $(element).val() + ',';
        // });
        // if (colorsSelected != '') {
        //     params['colors'] = colorsSelected;
        // }

        // Get all dynamic filter wrappers
        let dynamicFiltersList = $('.irantheme-wc-archive-dynamic-filter');

        // Loop on all filter wrapper
        dynamicFiltersList.each(function (index, element) {
            // For save selected checkbox value
            let filterSelected = '';

            // Get all checkbox checked
            let checkboxSelected = $(element).find(
                "input:checkbox[name='product_filter_item[]']:checked",
            );

            // Loop on all checkbox checked in current filter wrapper
            checkboxSelected.each(function (index, element) {
                // Append checked checkbox value
                filterSelected += $(element).val() + ',';
            });

            // If check box is selected
            if (filterSelected != '') {
                // Add to param
                params['filter_' + $(element).data('tax')] = filterSelected;
            }
        });

        let checkboxesStatusStock = $(
            "input:checkbox[name='product_status_in_stock']",
        ).is(':checked');
        if (checkboxesStatusStock != false) {
            params['in_stock'] = checkboxesStatusStock;
        }
        let checkboxesStatusSale = $(
            "input:checkbox[name='product_status_on_sale']",
        ).is(':checked');
        if (checkboxesStatusSale != false) {
            params['on_sale'] = checkboxesStatusSale;
        }
        let inputPriceFrom = parseFloat(
            $("input[name='irantheme_price_filter_input_from']").val(),
        );
        let inputPriceFromMin = parseFloat(
            $("input[name='irantheme_price_filter_input_from']").attr('min'),
        );
        let inputPriceTo = parseFloat(
            $("input[name='irantheme_price_filter_input_to']").val(),
        );
        let inputPriceToMax = parseFloat(
            $("input[name='irantheme_price_filter_input_to']").attr('max'),
        );
        if (
            inputPriceTo != inputPriceToMax ||
            inputPriceFrom != inputPriceFromMin
        ) {
            params['price_from'] = inputPriceFrom;
            params['price_to'] = inputPriceTo;
        }
        if (pageNumber != 0) {
            params['page_number'] = pageNumber;
        }
        // Check permalink type (if is a empty is equal to simple permalink otherwise is equal to postname permalink and other)
        if (iranthemeWpData.permalink_type == '') {
            // Get index of first '?' in url search section
            let indexStartStr = window.location.search.indexOf('?');
            // Get index of first '&' in url search section
            let indexEndStr = window.location.search.indexOf('&');
            // If index of '&' not founded, assign length of search section url
            if (indexEndStr == -1) {
                indexEndStr = window.location.search.length;
            }
            // Find search head of search section url between two chars of '?' and '&', for example 'product_cat' or 'post_type'
            let searchHead = window.location.search.substring(
                indexStartStr + 1,
                indexEndStr,
            );
            let new_url = '';
            // If product_cat has founded in search head , do not add search head to url
            if (searchHead.indexOf('post_type') >= 0) {
                new_url =
                    window.location.pathname +
                    '?' +
                    searchHead +
                    '&' +
                    $.param(params);
            } else {
                new_url = window.location.pathname + '?' + $.param(params);
            }
            window.history.pushState({ path: new_url }, '', new_url);
            this.applyArchiveFilter(pageNumber);
        } else {
            let new_url = '';
            new_url = window.location.pathname + '?' + $.param(params);
            window.history.pushState({ path: new_url }, '', new_url);
            this.applyArchiveFilter(pageNumber);
        }
    }

    // Check string start with another string
    startsWith(str, substr) {
        // Escape special characters in the substring
        const escapedSubstr = substr.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
        // Create a regular expression pattern to match the start of the string
        const pattern = new RegExp('^' + escapedSubstr);
        // Test if the string matches the pattern
        return pattern.test(str);
    }

    getURLParameter(sParam = '') {
        let current = this;
        var sPageURL = window.location.search.substring(1);
        var sURLVariables = sPageURL.split('&');
        let jsonOfParams = {};
        for (var i = 0; i < sURLVariables.length; i++) {
            var sParameterName = sURLVariables[i].split('=');

            // Decode the key to support non‑ASCII characters (e.g., "برند")
            var decodedKey = decodeURIComponent(sParameterName[0]);
            // Decode the value if it exists
            var decodedValue = sParameterName[1]
                ? decodeURIComponent(sParameterName[1])
                : '';

            // Check sParam value
            if (sParam != '') {
                // Check parameter name equal by sParam
                // if (sParameterName[0] == sParam) {
                //     // Return value of sParam
                //     return decodeURIComponent(sParameterName[1]);
                // }

                // Compare with the decoded key
                if (decodedKey == sParam) {
                    return decodedValue;
                }

                // If sParam equal by empty string
            } else {
                // Get dynamic filters parameter
                // if (current.startsWith(sParameterName[0], 'filter_')) {
                //     // Generate Json of all url parameter
                //     jsonOfParams[sParameterName[0]] = decodeURIComponent(
                //     );
                //         sParameterName[1],
                // }

                // Check the decoded key for dynamic filters (starts with 'filter_')
                if (current.startsWith(decodedKey, 'filter_')) {
                    jsonOfParams[decodedKey] = decodedValue;
                }
            }
        }

        // If sParam equal by empty string
        if (sParam == '') {
            // Return json object
            return jsonOfParams;
        }
    }

    detectsChangesFilters() {
        let current = this;

        $(document).on(
            'change',
            "input:checkbox[name='product_filter_item[]'], input:checkbox[name='product_status_in_stock'], input:checkbox[name='product_status_on_sale'], input[name='irantheme_price_filter_input_to'], input[name='irantheme_price_filter_input_from']",
            function (e) {
                if (
                    !$(e.target).parents(
                        '.irantheme-woocommerce-filter-navigation',
                    ).length
                ) {
                    current.addURLFilterParameter();
                }
            },
        );
        $(document).on('keyup', '#irantheme_wc_shop_search', function (e) {
            if (
                !$(e.target).parents('.irantheme-woocommerce-filter-navigation')
                    .length
            ) {
                // Get key code pressed
                var code = e.key || e.which;
                // Exception keys
                let keyArray = [
                    'Shift',
                    'Alt',
                    'Control',
                    'CapsLock',
                    'Meta',
                    'Pause',
                    'NumLock',
                    'Insert',
                    'Home',
                    'PageUp',
                    'Delete',
                    'End',
                    'PageDown',
                    'ScrollLock',
                    'ArrowUp',
                    'ArrowDown',
                    'ArrowLeft',
                    'ArrowRight',
                    'Escape',
                    'F1',
                    'F2',
                    'F3',
                    'F4',
                    'F5',
                    'F6',
                    'F7',
                    'F8',
                    'F9',
                    'F10',
                    'F11',
                    'F12',
                ];
                // Check if key code not extracted in exception keys
                if ($.inArray(code, keyArray) == -1) {
                    current.addURLFilterParameter();
                }
            }
        });
        $(document).on(
            'change',
            "input:checkbox[name='product_category_item[]']",
            function (e) {
                // Checking the type of page that should not be of category,tag,tax,author type
                if (
                    !['category', 'tag', 'tax', 'author'].includes(
                        current.pageType,
                    )
                ) {
                    // Call addURLFilterParameter function for add selected filter parameter to url
                    if (
                        !$(e.target).parents(
                            '.irantheme-woocommerce-filter-navigation',
                        ).length
                    ) {
                        current.addURLFilterParameter();
                    }
                }
            },
        );
        // Redirect to category url (when page is not archive)
        $("input:checkbox[name='product_category_item[]'].input-has-link").on(
            'click',
            function (e) {
                let url = $(this).siblings('.has-link').attr('href');
                if (url) {
                    window.location.href = url;
                }
            },
        );
        // Prevent check and uncheck category input (when page is not archive)
        $("input:checkbox[name='product_category_item[]'].input-has-link").on(
            'click',
            function (e) {
                let url = $(this).siblings('.has-link');
                if (url) {
                    e.preventDefault();
                    return false;
                }
            },
        );
        $(document).on('mouseup touchend', '#toSliderRangeInput', function (e) {
            // Call addURLFilterParameter function for add selected filter parameter to url
            if (
                !$(e.target).parents('.irantheme-woocommerce-filter-navigation')
                    .length
            ) {
                current.addURLFilterParameter();
            }
        });
        $(document).on(
            'mouseup touchend',
            '#fromSliderRangeInput',
            function (e) {
                // Call addURLFilterParameter function for add selected filter parameter to url
                if (
                    !$(e.target).parents(
                        '.irantheme-woocommerce-filter-navigation',
                    ).length
                ) {
                    current.addURLFilterParameter();
                }
            },
        );
    }

    applyArchiveFilter(pageNumber) {
        let clearAppliedFilterFlag = false;
        // Get ordering default type
        let orderingTypeDefault = $(
            '.irantheme-woocommerce-ordering-wrapper.irantheme-wc-ajax-ordering',
        )
            .find('.irantheme-woocommerce-ordering-list')
            .attr('data-ordering-default');
        // Get products wrapper
        let productListWrapper = $('.irantheme-wc-archive-products');
        // Get default pagination (static, not added by ajax)
        let defaultPagination = $(
            '.irantheme-woocommerce-products-section .irantheme-pagination:not(.irantheme-wc-archive-ajax-pagination)',
        );
        // Get preloader element
        let preLoader = $('.irantheme-wc-archive .irantheme-preloader-abs');

        let productCat;
        // Check permalink type (if is a empty is equal to simple permalink otherwise is equal to postname permalink and other)
        // Get product category filter selected from url parameter
        if (iranthemeWpData.permalink_type == '') {
            productCat = this.getURLParameter('p_category');
            if (productCat === undefined) {
                productCat = this.getURLParameter('product_cat');
                if (productCat === undefined) {
                    productCat = '';
                }
            }
        } else {
            let urlPathName = window.location.pathname;
            if (urlPathName.indexOf('product-category') >= 0) {
                productCat = this.getCategoryFromUrlPostNamePermalink();
            } else {
                productCat = this.getURLParameter('p_category');
                if (productCat === undefined) {
                    productCat = this.getURLParameter('product_cat');
                    if (productCat === undefined) {
                        productCat = '';
                    }
                }
            }
        }

        // Get search filter write from url parameter
        let search = this.getURLParameter('search');
        if (search === undefined) {
            search = '';
        }

        // Change status of filter clear btn
        if (productCat != '' || search != '') {
            clearAppliedFilterFlag = true;
        }

        // Get all dynamic filter
        let filterJsonObj = this.getURLParameter();

        // Change status of filter clear btn
        if (!isEmptyObject(filterJsonObj)) {
            clearAppliedFilterFlag = true;
        }

        // Get in stock status filter selected from url parameter
        let inStock = this.getURLParameter('in_stock');
        if (inStock === undefined) {
            inStock = 'false';
        }
        // Get on sale status filter selected from url parameter
        let onSale = this.getURLParameter('on_sale');
        if (onSale === undefined) {
            onSale = 'false';
        }

        // Change status of filter clear btn
        if (inStock != 'false' || onSale != 'false') {
            clearAppliedFilterFlag = true;
        }

        // Get start price filter selected from url parameter
        let priceFrom = this.getURLParameter('price_from');
        if (priceFrom === undefined) {
            priceFrom = $(
                ".irantheme-wc-archive-filter.filter-enable [name='irantheme_price_filter_input_from']",
            ).val();
        } else {
            // Change status of filter clear btn
            clearAppliedFilterFlag = true;
        }
        // Get end price filter selected from url parameter
        let priceTo = this.getURLParameter('price_to');
        if (priceTo === undefined) {
            priceTo = $(
                ".irantheme-wc-archive-filter.filter-enable [name='irantheme_price_filter_input_to']",
            ).val();
        } else {
            // Change status of filter clear btn
            clearAppliedFilterFlag = true;
        }
        // Get page number from url parameter
        let _pageNumber = this.getURLParameter('page_number');
        if (_pageNumber === undefined) {
            _pageNumber = pageNumber;
        }
        // Get ordering type selected from url parameter
        let orderingType = this.getURLParameter('ordering_type');
        if (orderingType === undefined) {
            orderingType = orderingTypeDefault;
        }

        // Change status of filter clear btn
        this.statusOfClearBtnInDesktop(clearAppliedFilterFlag);

        // Get admin url ajax from demo
        var ajax_url = iranthemeWpData.adminAjax;
        jQuery.ajax({
            url: ajax_url,
            type: 'post',
            data: {
                action: 'apply_filter_to_archive_product',
                search_keyword: search,
                product_cat: productCat,
                data_filter: filterJsonObj,
                in_stock: inStock,
                on_sale: onSale,
                price_from: priceFrom,
                price_to: priceTo,
                page_number: _pageNumber,
                ordering_type: orderingType,
                is_ajax: 1,
            },
            dataType: 'html',
            beforeSend: (response) => {
                $('.irantheme-wc-archive-ajax-error').css('display', 'none');
                $(preLoader).css('visibility', 'visible');
                $(preLoader).css('opacity', '1');
                $(defaultPagination).remove();
            },
            success: (response) => {
                $(productListWrapper).html('');
                $(productListWrapper).append(response);
            },
            complete: (response) => {
                this.productsResultCount();
                $(preLoader).css('visibility', 'hidden');
                $(preLoader).css('opacity', '0');
                // Wishlist completed
                new NavigationWishlist();
                new WoocommerceProducts();
                new Counter();
            },
            error: (req, status, error) => {
                $('.irantheme-wc-archive-ajax-error').css('display', 'flex');
                $(
                    '.irantheme-wc-archive-ajax-error .irantheme-wc-archive-ajax-error-desc',
                ).text(req.status + ' (' + req.statusText + ')');
                console.log(req);
            },
        });
    }

    paginationAction() {
        let current = this;
        $('.irantheme-wc-archive-products').on(
            'click',
            '.irantheme-pagination-holder .irantheme-wc-archive-ajax-pagination .page-numbers:not(.prev, .next)',
            function (e) {
                let pageSelected = $(this);
                let pageSelectedVal = pageSelected.attr('data-page');
                current.addURLFilterParameter(pageSelectedVal);
            },
        );
        $('.irantheme-wc-archive-products').on(
            'click',
            '.irantheme-pagination-holder .irantheme-wc-archive-ajax-pagination .page-numbers.next',
            function (e) {
                let pageSelected = $(this);
                let allPageNumbers = $('.irantheme-wc-archive-products').find(
                    '.irantheme-pagination-holder .irantheme-wc-archive-ajax-pagination .page-numbers:not(.prev, .next)',
                );
                let pageSelectedVal = pageSelected.attr('data-page');
                allPageNumbers.each(function (index, element) {
                    if ($(element).hasClass('current')) {
                        current.addURLFilterParameter(
                            $(element).next().attr('data-page'),
                        );
                    }
                });
            },
        );
        $('.irantheme-wc-archive-products').on(
            'click',
            '.irantheme-pagination-holder .irantheme-wc-archive-ajax-pagination .page-numbers.prev',
            function (e) {
                let pageSelected = $(this);
                let allPageNumbers = $('.irantheme-wc-archive-products').find(
                    '.irantheme-pagination-holder .irantheme-wc-archive-ajax-pagination .page-numbers:not(.prev, .next)',
                );
                let pageSelectedVal = pageSelected.attr('data-page');
                allPageNumbers.each(function (index, element) {
                    if ($(element).hasClass('current')) {
                        current.addURLFilterParameter(
                            $(element).prev().attr('data-page'),
                        );
                    }
                });
            },
        );
    }

    // Set navigation offset top
    filterNavigationEnable() {
        let mainWrapper = $('.irantheme-wc-archive');
        let desktopClearBtn = $(
            '.irantheme-wc-archive-top-bar .irantheme-woocommerce-filter-clear',
        );
        if ($(document).width() <= 992) {
            let filterCol = $('.irantheme-wc-archive-filter-col')
                .find('.irantheme-wc-archive-filter')
                .children();
            let filterNav = this.navigationFilter.find(
                '.irantheme-wc-archive-filter',
            );
            desktopClearBtn.css('display', 'none');
            filterCol.appendTo(filterNav);
            mainWrapper.addClass('irantheme-wc-filter-sidebar');
            mainWrapper.addClass('irantheme-wc-archive-hide-filtering');
            mainWrapper.removeClass('irantheme-wc-archive-show-filtering');
            this.navigationFilter
                .find('.irantheme-wc-archive-filter')
                .addClass('filter-enable');
            $('.irantheme-wc-archive-filter-col')
                .find('.irantheme-wc-archive-filter')
                .removeClass('filter-enable');
            // Init price range filter
            this.priceMultiRangeSlider();
        } else {
            let filterCol = $('.irantheme-wc-archive-filter-col').find(
                '.irantheme-wc-archive-filter',
            );
            let filterNav = this.navigationFilter
                .find('.irantheme-wc-archive-filter')
                .children();
            desktopClearBtn.attr('style', '');
            filterNav.appendTo(filterCol);
            mainWrapper.removeClass('irantheme-wc-filter-sidebar');
            mainWrapper.removeClass('irantheme-wc-archive-hide-filtering');
            mainWrapper.addClass('irantheme-wc-archive-show-filtering');
            this.close();
            this.navigationFilter
                .find('.irantheme-wc-archive-filter')
                .removeClass('filter-enable');
            $('.irantheme-wc-archive-filter-col')
                .find('.irantheme-wc-archive-filter')
                .addClass('filter-enable');
            // Init price range filter
            this.priceMultiRangeSlider();
        }
    }

    // Close nav
    close() {
        this.navigationFilter.removeClass('active');
        this.wrapperMask.fadeOut();
        $('.irantheme-woocommerce-filtering-status').removeClass('active');
    }

    // Apply selected filter in mobile mode
    applyFilterMobile() {
        this.addURLFilterParameter();
        this.close();
    }
    // Clear all selected filters in mobile mode
    clearFilterMobile() {
        let searchInput = $('#irantheme_wc_shop_search');
        searchInput.val('');
        let checkboxesElem = $(
            "input:checkbox[name='product_filter_item[]'], input:checkbox[name='product_status_in_stock'], input:checkbox[name='product_status_on_sale']",
        );
        let inputFromElem = $(
            "input[name='irantheme_price_filter_input_from']",
        );
        let inputToElem = $("input[name='irantheme_price_filter_input_to']");
        let categoryCheckboxesElem = $(
            "input:checkbox[name='product_category_item[]']",
        );
        let FromRangeSliderElem = $('#fromSliderRangeInput');
        let ToRangeSliderElem = $('#toSliderRangeInput');
        checkboxesElem.each(function (index, element) {
            $(element).prop('checked', false);
        });
        if (!['category', 'tag', 'tax', 'author'].includes(this.pageType)) {
            categoryCheckboxesElem.each(function (index, element) {
                $(element).prop('checked', false);
            });
        }
        inputFromElem.val(inputFromElem.attr('min'));
        inputToElem.val(inputToElem.attr('max'));
        FromRangeSliderElem.val(FromRangeSliderElem.attr('min'));
        ToRangeSliderElem.val(ToRangeSliderElem.attr('max'));
        // Init price range filter
        this.priceMultiRangeSlider();
        this.addURLFilterParameter();
        this.close();
    }
}
export default WoocommerceArchive;
